<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>调拨物品</div>
            <div class="">
              <el-button type="primary" size="small" @click="_goBack">返回</el-button>
              <el-button type="primary" size="small" @click="_openAllocationOrderInModel">
                <i class="el-icon-plus"></i>选择物品
              </el-button>
            </div>
          </div>
          <div class="">
            <table class="custom-table">
              <thead>
                <tr>
                  <th>商品图片</th>
                  <th>编号</th>
                  <th>名称</th>
                  <th>原仓库</th>
                  <th>目标仓库</th>
                  <th>规格</th>
                  <th>库存</th>
                  <th>数量</th>
                  <th>单价</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in allocationOrderInInfo.productManages" :key="item.productId + (item.defaultSpecValue ? item.defaultSpecValue.specId : '')">
                  <td>
                    <img style="width: 60px; height: 60px; border-radius: 5px;" :src="item.coverPhoto">
                  </td>
                  <td>{{ item.productId }}</td>
                  <td>{{ item.prodName }}</td>
                  <td>{{ item.shName }}</td>
                  <td>
                    <select class="custom-select" v-model="allocationOrderInInfo.targetShId" style="width:100%">
                      <option value="">请选择目标仓库</option>
                      <option v-for="shopHouse in allocationOrderInInfo.shopHouses" 
                              :key="shopHouse.shId"
                              :value="shopHouse.shId">
                        {{ shopHouse.shName }}
                      </option>
                    </select>
                  </td>
                  <td>{{ item.defaultSpecValue ? item.defaultSpecValue.specName : '' }}</td>
                  <td>{{ item.stock || (item.defaultSpecValue ? item.defaultSpecValue.stock : 0) }}</td>
                  <td>
                    <input class="custom-input" type="number" v-model.number="item.count" @keyup="_caculTotalMount" />
                  </td>
                  <td>
                    <input class="custom-input" type="number" v-model.number="item.price" @keyup="_caculTotalMount" />
                  </td>
                  <td>
                    <el-button type="text" @click="_deleteProduct(item)">删除</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>调拨说明</div>
          </div>
          <div class="">
            <el-form :model="allocationOrderInInfo" label-width="100px">
              <el-form-item label="申请说明">
                <el-input type="textarea" v-model="allocationOrderInInfo.remark" 
                          placeholder="必填，请填写申请说明"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="22" :offset="2">
        <div style="margin-bottom:10px; text-align:right">
          <el-button type="primary" @click="_submitApply">提交</el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductAndSpec" @chooseProductAndSpec="handleChooseProduct"></choose-product-and-spec>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveAllocationOrder, queryShopHouse } from '@/api/goods/allocationOrderApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec'

export default {
  name: 'AllocationOrderIn',
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      allocationOrderInInfo: {
        productManages: [],
        resourceSuppliers: [],
        shopHouses: [],
        total: 0,
        records: 1,
        remark: '',
        srcShId: '',
        srcShName: '',
        targetShId: '',
        targetShName: '',
        shopName: '',
        count: '',
        productId: '',
        specId: '',
        targetShopId: '',
        targetShopName: '',
        totalMount: 0.00,
        moreCondition: false,
        shopId: getShopId()
      }
    }
  },
  created() {
    this._listAllocationStorehouse()
  },
  methods: {
    handleChooseProduct(products) {
      // products 是一个数组
      if (products && products.length > 0) {
        products.forEach(product => {
          // 检查商品是否已存在（根据 productId 和 specId 判断）
          const exists = this.allocationOrderInInfo.productManages.some(
            item => item.productId === product.productId && 
                    item.defaultSpecValue && 
                    product.defaultSpecValue &&
                    item.defaultSpecValue.specId === product.defaultSpecValue.specId
          )
          
          if (!exists) {
            // 为商品添加必要的字段
            if (!product.count) {
              product.count = 1
            }
            if (!product.price) {
              product.price = product.defaultSpecValue ? product.defaultSpecValue.price : 0
            }
            if (!product.stock) {
              product.stock = product.defaultSpecValue ? product.defaultSpecValue.stock : 0
            }
            // 设置仓库信息（从商品中获取）
            if (product.shId) {
              this.allocationOrderInInfo.srcShId = product.shId
              this.allocationOrderInInfo.srcShName = product.shName || ''
            }
            if (product.shopId) {
              this.allocationOrderInInfo.shopId = product.shopId
            }
            this.allocationOrderInInfo.productId = product.productId
            if (product.defaultSpecValue && product.defaultSpecValue.specId) {
              this.allocationOrderInInfo.specId = product.defaultSpecValue.specId
            }
            // 加载目标仓库列表（每次选择商品时都加载，因为可能不同商品的原仓库不同）
            if (product.shId) {
              this._selectShopHouses(product.shId)
            }
            // 添加到商品列表
            this.allocationOrderInInfo.productManages.push(product)
          }
        })
        // 重新计算总金额
        this._caculTotalMount()
      }
    },
    _deleteProduct(_Product) {
      let index = this.allocationOrderInInfo.productManages.indexOf(_Product)
      if (index > -1) {
        this.allocationOrderInInfo.productManages.splice(index, 1)
      }
    },
    _openAllocationOrderInModel() {
      this.$refs.chooseProductAndSpec.open()
    },
    _listAllocationStorehouse(_page = 1, _rows = 100) {
      const param = {
        page: _page,
        row: _rows
      }
      console.log(param)
    },
    _goBack() {
      this.$router.go(-1)
    },
    async _submitApply() {
      if (this.allocationOrderInInfo.productManages.length < 1) {
        this.$message.warning('请选择物品')
        return
      }
      if (!this.allocationOrderInInfo.targetShId) {
        this.$message.warning('请选择目标仓库')
        return
      }
      if (this.allocationOrderInInfo.remark === '') {
        this.$message.warning('申请说明不能为空')
        return
      }

      let _saveFlag = true
      this.allocationOrderInInfo.productManages.forEach(item => {
        if (!item.count || item.count <= 0) {
          this.$message.warning('请填写调拨数量')
          _saveFlag = false
          return
        }
        const stock = item.stock || (item.defaultSpecValue ? item.defaultSpecValue.stock : 0)
        if (parseInt(item.count) > parseInt(stock)) {
          this.$message.warning(`${item.prodName}库存不足`)
          _saveFlag = false
          return
        }
        this.allocationOrderInInfo.count = item.count
      })

      if (!_saveFlag) return

      try {
        const res = await saveAllocationOrder(this.allocationOrderInInfo)
        this.$message.success(res.msg)
        this._goBack()
      } catch (error) {
        this.$message.error(error)
      }
    },
    _caculTotalMount() {
      let j = 0
      this.allocationOrderInInfo.productManages.forEach(item => {
        if (!isNaN(item.count) && !isNaN(item.price)) {
          j += parseFloat(item.count) * parseFloat(item.price).toFixed(2)
        } else {
          this.allocationOrderInInfo.totalMount = "请输入正确的数字"
          throw Error()
        }
      })
      this.allocationOrderInInfo.totalMount = j.toFixed(2)
    },
    async _selectShopHouses(shId) {
      const param = {
        shId: shId,
        shopId: this.allocationOrderInInfo.shopId,
        flag: "1",
        page: 1,
        row: 50
      }
      try {
        const res = await queryShopHouse(param)
        this.allocationOrderInInfo.shopHouses = res.data || []
        console.log('目标仓库列表:', this.allocationOrderInInfo.shopHouses)
      } catch (error) {
        console.error('加载目标仓库失败:', error)
        this.$message.error(error.message || error || '加载目标仓库失败')
        this.allocationOrderInInfo.shopHouses = []
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ibox-tools {
  position: relative;
  top: 10px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #EBEEF5;
  font-size: 14px;
  color: #606266;
}

.custom-table thead {
  background-color: #F5F7FA;
}

.custom-table th {
  padding: 12px 0;
  text-align: center;
  border-bottom: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  font-weight: 500;
  color: #909399;
  font-size: 14px;
}

.custom-table th:last-child {
  border-right: none;
}

.custom-table tbody tr {
  border-bottom: 1px solid #EBEEF5;
}

.custom-table tbody tr:last-child {
  border-bottom: none;
}

.custom-table tbody tr:hover {
  background-color: #F5F7FA;
}

.custom-table td {
  padding: 12px 0;
  text-align: center;
  border-right: 1px solid #EBEEF5;
}

.custom-table td:last-child {
  border-right: none;
}

.custom-input {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #FFF;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-input:hover {
  border-color: #C0C4CC;
}

.custom-input:focus {
  border-color: #409EFF;
  outline: none;
}

.custom-input:disabled {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}

.custom-select {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #FFF;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
}

.custom-select:hover {
  border-color: #C0C4CC;
}

.custom-select:focus {
  border-color: #409EFF;
  outline: none;
}

.custom-select:disabled {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}
</style>